<template>
    <ul class="car-tab">
        <li class="tab-item"
            :class="{
                'active': active === 'zaishou'
            }">
            <a @click="doSelect('zaishou')">
                <h4>
                    <span class="tab-item-carstatus">出售中</span>
                    <span class="car-kind-count-ctn">
                        <span>(</span>
                        <span class="car-kind-count-saling">{{ countZaiShou }}</span>
                        <span>)</span>
                    </span>
                </h4>
            </a>
        </li>
        <li class="tab-item"
            :class="{
                'active': active === 'yishou'
            }">
            <a @click="doSelect('yishou')">
                <h4>
                    <span class="tab-item-carstatus">已售</span>
                    <span class="car-kind-count-ctn">
                        <span>(</span>
                        <span class="car-kind-count-sold">{{ countYiShou }}</span>
                        <span>)</span>
                    </span>
                </h4>
            </a>
        </li>
        <li class="tab-item"
            :class="{
                'active': active === 'yiyuding'
            }">
            <a @click="doSelect('yiyuding')">
                <h4>
                    <span class="tab-item-carstatus">已预订</span> 
                    <span class="car-kind-count-ctn">
                        <span>(</span>
                        <span class="car-kind-count-sold">{{ countYiyuding }}</span>
                        <span>)</span>
                    </span>
                </h4>
            </a>
        </li>
    </ul>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    export default {
        data() {
            return {
                key: 'searchType',
                active: locationObj.search.get('searchType') || 'zaishou'
            };
        },
        computed: {
            countZaiShou() {
                return window._qiwa.page_global.listCount.zaiShou;
            },
            countYiShou() {
                return window._qiwa.page_global.listCount.yiShou;
            },
            countYiyuding() {
                return window._qiwa.page_global.listCount.yiyuding;
            }
        },
        methods: {
            doSelect(value) {
                if (value) {
                    locationObj
                        .s(this.key, value)
                        .s('index', null).go();
                } else {
                    locationObj.s(this.key, null)
                        .s('index', null).go();
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// CarTab.vue?0c1085b2